export const LAST_MINUTE_PRODUCT_NAME = 'Last Minute Escapes'
export const LAST_MINUTE_PRODUCT_CODE = 'lastMinute'
export const LAST_MINUTE_LABEL_ID = '2ne0nnfbal87aj5cs98n'

// TODO remove after March 13th 2023 in favour of functionality to allow property to override urgency label -> CONLT-572
// key is property id, value is the urgency override label
export const LME_URGENCY_OVERRIDES = {
  '2bffcdd0-3e4d-11ea-881d-c912d7b4cc7e': 'Travel in next 14 days',
}
